import * as requestFromServer from "./UserAuthorizationCrud";
import { userAuthorizationSlice } from "./UserAuthorizationSlice";

const {actions} = userAuthorizationSlice;

export const getList = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getUsers = userType => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getUsers(userType)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAuthorities = (userType, userId) => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .getAuthorities(userType, userId)
    .then(response => {
      dispatch(actions.authoritiesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveAuthorities = (userId, userType, moduleAndAuthorities) => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .saveAuthorities(userId, userType, moduleAndAuthorities)
    .then(response => {
      dispatch(actions.authoritiesSaved());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const cleanAuthorities = () => dispatch => {
  dispatch(actions.authoritiesCleaned());
}

export const cleanAll = () => dispatch => {
  dispatch(actions.allCleaned());
}